import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { NgClass } from '@angular/common'
import { MatTooltip } from '@angular/material/tooltip'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import moment from 'moment'
import { SnackbarCustomService } from '../snackbar/snackbar-custom.service'

@Component({
  selector: 'form-search-quote-request-tg',
  imports: [
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    NgClass,
    MatTooltip,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatOption,
    MatSelect,
  ],
  templateUrl: './form-search-quote-request-tg.component.html',
  styleUrl: './form-search-quote-request-tg.component.scss',
})
export class FormSearchQuoteRequestTgComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
  ) {}

  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  formSearch: FormGroup = new FormGroup({})
  @Output() responseSearch = new EventEmitter()
  @Input() search: string = ''

  listStatus: any[] = [
    { id: 0, description: 'Todos' },
    { id: 1, description: 'Aberta' },
    { id: 2, description: 'Cancelada' },
    { id: 3, description: 'Cotação em Andamento' },
    { id: 4, description: 'Fechado' },
  ]

  ngOnInit() {
    this.createForm()
    this.sendSearch(false)
  }

  ngOnChanges() {
    // this.updateSearch()
  }

  // updateSearch() {
  //   this.formSearch.get('search')?.setValue(this.search ?? '')
  // }

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      originCity: [''],
      originState: [''],
      destinationCity: [''],
      destinationState: [''],
      tgCode: [''],
      event: [''],
      client: [''],
      subClient: [''],
      dateStart: [''],
      dateEnd: [''],
      consultantClient: [''],
      consultantTg: [''],
      serviceType: [''],
      service: [''],
      vehicleType: [''],
      driverType: [''],
      status: [0],
    })
  }

  sendSearch(search: boolean = true) {
    if (search && this.checkSearch()) {
      const searchModel = {
        tg: this.formSearch.get('tgCode')!.value,
        eventoNome: this.formSearch.get('event')!.value,
        nomeCliente: this.formSearch.get('client')!.value,
        nomeSubCliente: this.formSearch.get('subClient')!.value,
        dataInicio:
          this.formSearch.get('dateStart')!.value != ''
            ? moment(this.formSearch.get('dateStart')!.value).format(
                'DD/MM/YYYY',
              )
            : '',
        dataFinal:
          this.formSearch.get('dateEnd')!.value != ''
            ? moment(this.formSearch.get('dateEnd')!.value).format('DD/MM/YYYY')
            : '',
        nomeConsultor: this.formSearch.get('consultantClient')!.value,
        consultorComercial: this.formSearch.get('consultantTg')!.value,
        descricaoTipoServico: this.formSearch.get('serviceType')!.value,
        descricaoServico: this.formSearch.get('service')!.value,
        descricaoTipoVeiculo: this.formSearch.get('vehicleType')!.value,
        descricaoTipoMotorista: this.formSearch.get('driverType')!.value,
        origemCidade: this.formSearch.get('originCity')!.value,
        origemEstado: this.formSearch.get('originState')!.value,
        destinoCidade: this.formSearch.get('destinationCity')!.value,
        destinoEstado: this.formSearch.get('destinationState')!.value,
        statusId: this.formSearch.get('status')!.value,
      }
      this.responseSearch.emit({ search: search, model: searchModel })
    } else if (!search) {
      this.formSearch.get('tgCode')!.setValue('')
      this.formSearch.get('event')!.setValue('')
      this.formSearch.get('client')!.setValue('')
      this.formSearch.get('subClient')!.setValue('')
      this.formSearch.get('dateStart')!.setValue('')
      this.formSearch.get('dateEnd')!.setValue('')
      this.formSearch.get('consultantClient')!.setValue('')
      this.formSearch.get('consultantTg')!.setValue('')
      this.formSearch.get('serviceType')!.setValue('')
      this.formSearch.get('service')!.setValue('')
      this.formSearch.get('vehicleType')!.setValue('')
      this.formSearch.get('driverType')!.setValue('')
      this.formSearch.get('originCity')!.setValue('')
      this.formSearch.get('originState')!.setValue('')
      this.formSearch.get('destinationCity')!.setValue('')
      this.formSearch.get('destinationState')!.setValue('')
      this.formSearch.get('status')!.setValue(0)
      this.responseSearch.emit({
        // search: search,
        search: true,
        model: {
          tg: '',
          eventoNome: '',
          nomeCliente: '',
          nomeSubCliente: '',
          dataInicio: '',
          dataFinal: '',
          nomeConsultor: '',
          consultorComercial: '',
          descricaoTipoServico: '',
          descricaoServico: '',
          descricaoTipoVeiculo: '',
          descricaoTipoMotorista: '',
          origemCidade: '',
          origemEstado: '',
          destinoCidade: '',
          destinoEstado: '',
          statusId: 0,
        },
      })
    }
  }

  checkSearch() {
    if (
      this.formSearch.get('tgCode')!.value.trim().length > 0 ||
      this.formSearch.get('event')!.value.trim().length > 0 ||
      this.formSearch.get('client')!.value.trim().length > 0 ||
      this.formSearch.get('subClient')!.value.trim().length > 0 ||
      this.formSearch.get('consultantClient')!.value.trim().length > 0 ||
      this.formSearch.get('consultantTg')!.value.trim().length > 0 ||
      this.formSearch.get('dateStart')!.value ||
      this.formSearch.get('dateEnd')!.value ||
      this.formSearch.get('consultantClient')!.value ||
      this.formSearch.get('consultantTg')!.value ||
      this.formSearch.get('serviceType')!.value ||
      this.formSearch.get('service')!.value ||
      this.formSearch.get('vehicleType')!.value ||
      this.formSearch.get('driverType')!.value ||
      this.formSearch.get('originCity')!.value ||
      this.formSearch.get('originState')!.value ||
      this.formSearch.get('destinationCity')!.value ||
      this.formSearch.get('destinationState')!.value ||
      // this.formSearch.get('status')!.value == 0 ||
      this.formSearch.get('status')!.value != ''
    ) {
      return true
    } else {
      return false
    }
  }

  checkForm() {
    const input = this.formSearch.get('event')?.value
    if (input.trim().length == 0 || input.trim().length > 3) {
      return true
    } else {
      return false
    }
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }
}
